import { render, staticRenderFns } from "./AmountField.vue?vue&type=template&id=940e0ba6"
import script from "./AmountField.vue?vue&type=script&lang=js"
export * from "./AmountField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports